export default [
    {
      header: 'Questionnaires',
      title: 'Questionnaires',
      icon: 'FileTextIcon',
      route: 'questionnaires-list',
      resource: 'AdminAccess',

    //   children: [
    //     {
    //       title: 'eCommerce',
    //       route: 'dashboard-ecommerce',
    //       icon: 'ShoppingCartIcon',
    //     },
    //     {
    //       title: 'Analytics',
    //       route: 'dashboard-analytics',
    //       icon: 'ActivityIcon',
    //     },
    //   ],
    },
  ]
  